// noinspection DuplicatedCode
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import utils from './utils'
import common from './common'
import axios from 'axios'
import ElementUI from 'element-ui'
import'element-ui/lib/theme-chalk/index.css'
import * as echarts from "echarts";
import 'echarts-wordcloud';
Vue.prototype.$echarts = echarts;
import store from './store'
Vue.config.productionTip = false
Vue.prototype.$store = store
Vue.use(common);

Vue.use(ElementUI);
Vue.use(utils);
import {BmlHeatmap} from 'vue-baidu-map'

Vue.component('bml-heat-map', BmlHeatmap)

Vue.prototype.$axios = axios.create({
  baseURL: 'http://127.0.0.1:8080/',
  timeout: 6000
})

import BaiduMap from 'vue-baidu-map'

Vue.use(BaiduMap, {
  ak: '8LubpSTkKrWheO3CE8EPRBt7KH8gbJnX'
})

// Vue.prototype.$axios.interceptors.request.use(config => {
//   let showLoading =config.headers.showLoading
//   if(showLoading !==undefined && showLoading === false){
//     return config
//   }
//   Vue.prototype.$store.commit('addLoadingCount', 1)
//   return config
// })

// Vue.prototype.$axios.interceptors.response.use(response => {
//   let showLoading =response.config.headers.showLoading
//   if(showLoading !==undefined && showLoading === false){
//     return response
//   }
//   setTimeout(()=>{
//     Vue.prototype.$store.commit('removeLoadingCount', 1)
//   },200)
//   return response
// })



new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
